import React, { useState, useEffect } from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import Button from '@mui/material/Button';
import { Flex } from "../../style";
import "../../index.css";
import config from '../../config';
import ConfirmationDialog from '../Confirmation';
import getCookie from '../../hooks/getCookie';

const DetailBox = styled('div')(({ theme }) => ({
  backgroundColor: '#313940',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3),
  color: 'white',
  maxWidth: 300,
  minWidth: 280,
  overflowY: 'auto',
}));

const colorPalette = [
  '#216e4e', '#7f5f01', '#ae2e24', '#5e4db2', '#4c6b1f', '#943d73', '#596773', '#a54800', '#0055cc', '#FFEE58', '#B32D00', '#7E41AC'
];

const Capa = ({ anchorEl, onClose, selectedCard, fetchCoverImage, fetchCoverColor }) => {
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  // ip do backend
  const backendIp = config.backend_ip;
  const username = getCookie('username');
  const sessionId = getCookie('session_id');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(`${backendIp}/api/board/ti/list_images_in_cards`);
        setImages(response.data);
      } catch (error) {
        return null;
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const fetchCurrentCoverImage = () => {
      if (selectedCard.id) {
        const currentImage = images.find(image => image.card_id === selectedCard.id);
        if (currentImage) {
          setSelectedImage(currentImage.image_id);
        } else {
          setSelectedImage(null);
        }
      }
    };

    fetchCurrentCoverImage();
  }, [selectedCard, images]);

  const handleColorClick = async (color) => {
    setSelectedColor(color);
    try {
      handleRemoveCover()
      await axios.put(`${backendIp}/api/board/ti/save_cover`, {
        color_hex: color,
        card_id: selectedCard.id,
        user: username,
        session_id: sessionId
      });
      fetchCoverColor();
    } catch (error) {
      return null;
    }
  };

  const handleRemoveCover = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/remove_cover`, {
        card_id: selectedCard.id,
        user: username,
        session_id: sessionId
      });
      fetchCoverColor();
      fetchCoverImage();
      setSelectedImage(null); // Remove a imagem da capa exibida
      setDialogOpen(false);
    } catch (error) {
      return null;
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);

    try {
      handleRemoveCover()
      const response = await axios.put(`${backendIp}/api/board/ti/upload_image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const { data } = response;
      const file_id = data.file_id;

      await axios.put(`${backendIp}/api/board/ti/save_image`, {
        file_id: file_id,
        card_id: selectedCard.id,
        username: username,
        session_id: sessionId
      });

      setDialogOpen(false);
      fetchCoverImage();
      setSelectedImage(file_id);
    } catch (error) {
      return null;
    }
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      handleFileChange(event);
    }
  };

  const handleClose = () => {
    onClose();
    setSelectedImage(null);
    setSelectedColor('');
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <p className='paragraph-members'>Capa</p>
          <Flex style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <p className='paragraph-members2'>Cores</p>
            <Button variant="outlined" component="span" onClick={() => setDialogOpen(true)}  className='button-checklist'>
              Excluir capa
            </Button>
            <ConfirmationDialog
              open={dialogOpen}
              onClose={() => setDialogOpen(false)}
              onConfirm={handleRemoveCover}
              title="Confirmar Exclusão"
              message="Tem certeza de que deseja excluir a capa? Esta ação não pode ser desfeita."
            />
          </Flex>
            <br></br>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 40px)', gap: '10px', alignItems: 'center', justifyContent: 'center' }}>
            {colorPalette.map((color, index) => (
              <div
                key={index}
                onClick={() => handleColorClick(color)}
                style={{
                  backgroundColor: color,
                  width: '40px',
                  height: '30px',
                  cursor: 'pointer',
                  border: selectedColor === color ? '1px solid white' : 'none',
                  borderRadius: '5px',
                }}
              ></div>
            ))}
          </div>
          <br></br>
          <p className='paragraph-members4'>Anexos</p>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            onChange={handleImageChange}
          />
          <label htmlFor="raised-button-file" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <Button variant="outlined" component="span"  className='button-checklist'>
              Carregar uma imagem de capa
            </Button>
          </label>
          {selectedImage && (
            <div style={{ marginTop: '10px' }}>
              <img src={`${backendIp}/api/board/ti/get_image/${selectedImage}`} alt="Capa" style={{ maxWidth: '100%', borderRadius: '10px' }} />
            </div>
          )}
        </DetailBox>
      </Popover>
    </Box>
  );
};

export default Capa;
